import React, { useContext } from 'react'
import { PollGlyphIcon24 } from 'assets/icons'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import FormBlock from './FormBlock'

const ObjectSurveyBlock = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)
   const hasSurvey = initiative.appsSurveyEnabled && initiative.appsSurveyFormElements.length > 0
   if (!hasSurvey) {
      return null
   }

   return (
      <div className="flex gap-6 bg-neutral-50 border border-solid border-neutral-200 rounded-xl p-6">
         <div className="flex-0 w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center bg-[#7d3ce7]/10">
            <PollGlyphIcon24 width="16px" height="16px" color="#7d3ce7" />
         </div>
         <div className="flex-1">
            <FormBlock />
         </div>
      </div>
   )
}

export default ObjectSurveyBlock
